import { Controller } from "@hotwired/stimulus"

// Removes the element when its close button is clicked (no auto-dismiss).
export default class extends Controller {
  dismiss() {
    this.element.remove()
  }
}
